import { useMemo } from "react";
import { useSelector } from "react-redux";

import { InternalApi } from "../config/InternalApi";
import { useSite } from "./site";

export const useInternalApi = () => {
	const { backendApiUrl } = useSite();
	const auth = useSelector((state) => state.auth);
	const jwtToken = auth.user?.jwtToken;
	const pltToken = auth.user?.pltToken;
	const timezoneOffset = new Date().getTimezoneOffset();

	return useMemo(
		() =>
			new InternalApi({
				apiUrl: backendApiUrl,
				timezoneOffset,
				token: pltToken ?? jwtToken,
			}),
		[backendApiUrl, jwtToken, pltToken, timezoneOffset],
	);
};
